<template lang="pug" src="./template.pug">
</template>
<style scoped lang="scss" src="./style.scss"></style>

<script>
import bus from 'utils/js/bus';
let self;
export default {
    name: "Header",
    props: {
        msg: String,
    },
    data(){
        return {
            show:true
        }
    },
    methods: {
        buildListeners() {
			bus.$on('showLoading', show=>{
				self.show = show;
			});
        },
    },
    mounted() {
        self = this;
        this.buildListeners();
    }
};
</script>